import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6ab62188"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "main-study"
}
const _hoisted_2 = { class: "wrapper" }
const _hoisted_3 = { key: 1 }

import {onBeforeMount, ref, watch} from "vue";
import {LocationQuery, useRoute, useRouter} from "vue-router";
import MainNav from './components/MainNav.vue'
import useCourseSchedule from "../../composables/useCourseSchedule";
import MainContent from "@/pages/Main/components/MainContent.vue";
import {CoursePlanPartVO, CoursePlanVO} from "@/apis/course";


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const router = useRouter()
const route = useRoute()
const {courseVO, getCourseSchedule} = useCourseSchedule()
const showNav = ref<boolean>(true)

const currentPlan = ref<CoursePlanVO>()
const currentPart = ref<CoursePlanPartVO>()
const handlePartChange = ({plan, part}: { plan: CoursePlanVO, part: CoursePlanPartVO }) => {
  plan.show = true
  currentPlan.value = plan
  currentPart.value = part
}
const findCurrent = ({planId, partId}: LocationQuery) => {
  let currentPlanId = planId || courseVO.value?.userCourse.lastPlanId || 0
  let currentPartId = partId || courseVO.value?.userCourse.lastPlanPartId || 0
  const plan = (courseVO.value?.plans.find(plan => plan.id === +currentPlanId) || courseVO.value?.plans[0]) as CoursePlanVO
  const part = (plan?.parts.find(part => part.id === +currentPartId) || plan?.parts[0]) as CoursePlanPartVO
  handlePartChange({plan, part})
}

watch(currentPart, currentPart => {
  router.replace({query: {planId: currentPlan.value?.id, partId: currentPart?.id}})
})

onBeforeMount(() => {
  getCourseSchedule(+route.params.courseId)
    .then(() => {
      findCurrent({...route.query})
    })
})

return (_ctx: any,_cache: any) => {
  return (_unref(courseVO))
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          (showNav.value && currentPlan.value && currentPart.value)
            ? (_openBlock(), _createBlock(MainNav, {
                key: 0,
                courseVO: _unref(courseVO),
                currentPlan: currentPlan.value,
                currentPart: currentPart.value,
                onPartChange: handlePartChange
              }, null, 8, ["courseVO", "currentPlan", "currentPart"]))
            : _createCommentVNode("", true),
          (currentPart.value)
            ? (_openBlock(), _createBlock(MainContent, {
                key: 1,
                part: currentPart.value,
                onNavTrigger: _cache[0] || (_cache[0] = ($event: any) => (showNav.value = !showNav.value))
              }, null, 8, ["part"]))
            : _createCommentVNode("", true)
        ])
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_3, " loading... "))
}
}

})